<template>
  <div class="community">
    <div class="carousel">
      <p>**阿黛拉原创作品30个，荣获”原创超人“称号</p>
      <swiper ref="mySwiper" :options="swiperOptions" class="swiper-wrappe">
        <swiper-slide class="swiper-slide">
          <div class="demo-carousel">
            <img src="@/assets/community/u1.png" alt />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="@/assets/community/u2.png" alt />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="@/assets/community/u3.png" alt />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="@/assets/community/u4.png" alt />
        </swiper-slide>
        <!-- 分页器 -->
        <div
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
        ></div>
        <!-- 左右箭头 -->
        <div
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
      </swiper>
    </div>

    <div class="wave">
      <img src="@/assets/home/wave.png" alt />
    </div>
    <div class="content">
      <div class="wdd" id="basic_usage">
        <div class="title">
          <svg-icon
            icon-class="star"
            style="font-size: 43px; vertical-align: middle"
          ></svg-icon>
          <span class="tip">精选作品</span>
        </div>
      </div>
      <div class="wdd">
        <Row
          type="flex"
          style="margin-top: 20px; padding: 0px 68px; width: 1130px"
        >
          <i-col
            span="5"
            class="card-list"
            v-for="(item, index) in greatWorkResult.records"
            :key="index"
          >
            <Card :shadow="true" class="card">
              <div class="pic" @click="toDetail(item.id)">
                <img :src="item.coverFileUrl" alt />
              </div>
              <div class="card-content">
                <p class="title" @click="toDetail(item.id)">
                  {{ item.workName }}
                </p>
                <Row type="flex" justify="space-between" style="margin: 10px 0">
                  <i-col>初学者</i-col>
                  <i-col>scratch</i-col>
                </Row>
                <p class="num">
                  <span>
                    <i class="fa fa-thumbs-up"></i>
                    {{ item.starNum }}
                  </span>
                  <span>
                    <i class="fa fa-comment-o"></i>
                    {{ item.commentNum }}
                  </span>
                  <span>
                    <i class="fa fa-eye"></i>
                    {{ item.viewNum }}
                  </span>
                </p>
              </div>
              <Row type="flex" align="middle" justify="center" class="footer">
                <i-col>
                  <span
                    class="fa fa-user q"
                    @click="toFriend(item.userId)"
                  ></span>
                  <span @click="toFriend(item.userId)">
                    {{ item.realname }}
                  </span>
                </i-col>
              </Row>
            </Card>
          </i-col>
        </Row>
        <Page
          class="page"
          :total="greatWorkResult.total"
          :current="greatWorkResult.current"
          :page-size="greatWorkResult.size"
          @on-change="changePage"
        />
      </div>
      <div class="wdd">
        <div class="title" id="basic_usage2">
          <svg-icon
            icon-class="rank"
            style="font-size: 43px; vertical-align: middle"
          ></svg-icon>
          <span class="tip">劲作排行榜</span>
          <div class="select">
            <Row type="flex" justify="space-between">
              <i-col>
                <a
                  href="javascript:void(0)"
                  @click="getWorkRank('week', 1)"
                  :class="workRankType == 'week' ? 'selected' : ''"
                  >本周作品</a
                >
                <a
                  href="javascript:void(0)"
                  @click="getWorkRank('year', 1)"
                  :class="workRankType == 'year' ? 'selected' : 'colorWihte'"
                  >年度作品</a
                >
              </i-col>
              <i-col>
                <Select
                  class="select"
                  value
                  size="small"
                  style="width: 150px; margin: 0 50px"
                  @on-change="getWorkRank()"
                  v-model="workRankOrderBy"
                >
                  <Option value="star">按点赞量</Option>
                  <Option value="view">按点击量</Option>
                  <Option value="time">按最新时间</Option>
                </Select>
              </i-col>
            </Row>
          </div>
        </div>
        <Row
          type="flex"
          style="margin-top: 20px; padding: 0px 68px; width: 1130px"
        >
          <i-col
            span="5"
            class="card-list"
            v-for="(item, index) in workRankResult.records"
            :key="index"
          >
            <Card :shadow="true" class="card">
              <div class="pic" @click="toDetail(item.id)">
                <img :src="item.coverFileUrl" alt />
              </div>
              <div class="card-content">
                <p class="title" @click="toDetail(item.id)">
                  {{ item.workName }}
                </p>
                <Row type="flex" justify="space-between" style="margin: 10px 0">
                  <i-col>初学者</i-col>
                  <i-col>scratch</i-col>
                </Row>
                <p class="num">
                  <span>
                    <i class="fa fa-thumbs-up"></i>
                    {{ item.starNum }}
                  </span>
                  <span>
                    <i class="fa fa-comment-o"></i>
                    {{ item.commentNum }}
                  </span>
                  <span>
                    <i class="fa fa-eye"></i>
                    {{ item.viewNum }}
                  </span>
                </p>
              </div>
              <Row type="flex" align="middle" justify="center" class="footer">
                <i-col>
                  <span
                    class="fa fa-user q"
                    @click="toFriend(item.userId)"
                  ></span>
                  <span @click="toFriend(item.userId)">
                    {{ item.realname }}
                  </span>
                </i-col>
              </Row>
            </Card>
          </i-col>
        </Row>
        <Page
          class="page"
          :current="workRankResult.current"
          :total="workRankResult.total"
          :page-size="workRankResult.size"
          @on-change="changePage1"
        />
      </div>
      <div class="wdd">
        <div class="title" id="basic_usage1">
          <svg-icon
            icon-class="starblue"
            style="font-size: 43px; vertical-align: middle"
          ></svg-icon>
          <span class="tip">精选主题</span>
          <Row
            type="flex"
            justify="space-between"
            style="
              padding: 20px 40px;
              margin: 50px 0 60px 0;
              width: 1050px;
              margin: 0 auto;
            "
          >
            <i-col>
              <a href="/selectedSubject1" target="_blank">
                <img src="@/assets/community/u142.png" alt />
              </a>
            </i-col>
            <i-col>
              <a href="/selectedSubject2" target="_blank">
                <img src="@/assets/community/u143.png" alt />
              </a>
            </i-col>
          </Row>
        </div>
        <div class="title" id="basic_usage3">
          <svg-icon
            icon-class="gold"
            style="font-size: 43px; vertical-align: middle"
          ></svg-icon>
          <span class="tip">社区牛人</span>
        </div>
      </div>
      <div class="wdd">
        <Carousel v-if="studentRankResult.records">
          <Carousel-item v-for="i in caroulLength" :key="i.id">
            <Row
              type="flex"
              justify="center"
              style="padding: 30px 0px; width: 900px; margin: 30px auto"
            >
              <i-col
                span="4"
                class="card-list2"
                v-for="(item, index) in studentRankResult.records.slice(
                  (i - 1) * 5,
                  i * 5
                )"
                :key="index"
              >
                <Card :shadow="true" class="card">
                  <div class="pic">
                    <img
                      @click="toFriend(item.id)"
                      :src="
                        item.avatar ||
                        item.headimgurl ||
                        '/static/img/avatar.jpg'
                      "
                      alt
                    />
                  </div>
                  <div class="card-content">
                    <p class="title" @click="toFriend(item.id)">
                      {{ item.realname || item.nickname }}
                    </p>
                    <Row type="flex" justify="center" class="num">
                      <i-col span="8">
                        <span>关注者</span>
                        <p>{{ item.attention }}</p>
                      </i-col>
                      <i-col span="8">
                        <span>粉丝</span>
                        <p>{{ item.idol }}</p>
                      </i-col>
                      <i-col span="8">
                        <span>发布</span>
                        <p>{{ item.workNum }}</p>
                      </i-col>
                    </Row>
                  </div>
                  <Row type="flex" justify="center" class="tip">
                    <i-col span="8">初学者</i-col>
                    <i-col span="2" style="color: #cccc">|</i-col>
                    <i-col span="8">scratch</i-col>
                  </Row>
                </Card>
              </i-col>
            </Row>
          </Carousel-item>
        </Carousel>
      </div>
    </div>

    <Anchor show-ink class="anchor-link">
      <ul>
        <li>
          <svg-icon icon-class="cr1" @mouseover="showIndex = 1"></svg-icon>
          <div
            v-show="showIndex == 1"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage" title="全部" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr2" @mouseover="showIndex = 2"></svg-icon>
          <div
            v-show="showIndex == 2"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage" title="顶级创客" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr3" @mouseover="showIndex = 3"></svg-icon>
          <div
            v-show="showIndex == 3"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage" title="图形化" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr4" @mouseover="showIndex = 4"></svg-icon>
          <div
            v-show="showIndex == 4"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage" title="文本类" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr5" @mouseover="showIndex = 5"></svg-icon>
          <div
            v-show="showIndex == 5"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage" title="我的世界" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr7" @mouseover="showIndex = 7"></svg-icon>
          <div
            v-show="showIndex == 7"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage2" title="排行榜" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr6" @mouseover="showIndex = 6"></svg-icon>
          <div
            v-show="showIndex == 6"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage1" title="精选主题" />
          </div>
        </li>
        <li>
          <svg-icon icon-class="cr8" @mouseover="showIndex = 8"></svg-icon>
          <div
            v-show="showIndex == 8"
            class="word"
            @mouseleave="showIndex = ''"
          >
            <AnchorLink href="#basic_usage3" title="牛人" />
          </div>
        </li>
      </ul>
      <div class="more">
        <span>...</span>
        <p>更多</p>
      </div>
    </Anchor>
    <Modal
      v-model="isShowTip"
      title="提醒"
      width="408px"
      class="community-modal"
    >
      <div class="overtime">
        <Icon class="icon" type="ios-alert-outline" />
        <span>Hi，你好！ 你在社区已经停留超过1个小时。</span>
        <p>你的同学做出下面的TOP10的作品</p>
        <p>
          赚了
          <span style="color: #f28300">1000金币</span>
        </p>
        <img
          style="width: 180px; margin: 5px 0"
          src="@/assets/community/study.png"
          alt
        />
        <p style="color: #027db4">想学习更牛的编程技术，成为社区的牛人？</p>
      </div>
      <Row slot="footer" style="text-align: center" justify="space-around">
        <i-col :span="12">
          <Button @click="isShowTip = false">继续社区打磨</Button>
        </i-col>
        <i-col :span="12">
          <Button type="primary">
            <router-link to="mymenu">前往学习修炼</router-link>
          </Button>
        </i-col>
      </Row>
    </Modal>
  </div>
</template>
<script>
import request from "@/api/axios";
import {
  getWorkGreat,
  getWorkRank,
  communityCattle,
  communityOnline,
} from "@/api/community";
export default {
  data() {
    return {
      swiperOptions: {
        speed: 800,
        effect: "fade",
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      caroulLength: "1",
      showIndex: "",
      type: 1,
      isShowTip: false,
      workRankResult: {},
      workRankType: "year",
      workRankOrderBy: "star",
      greatWorkResult: {},
      studentRankResult: {},
      currentPage1: 1,
    };
  },
  mounted() {
    this.getWorkRank("", 1);
    this.getWorkGreat();
    this.getStudentRank();
  },
  created() {
    let that = this;
    // 一小时出现弹框
    setTimeout(() => {
      that.isShowTip = true;
    }, 1000 * 60 * 60);
    // 半小时在线累计积分
    setTimeout(() => {
      communityOnline(1800).then((res) => {});
    }, 1000 * 60 * 30);
  },
  methods: {
    changePage(page) {
      this.getWorkGreat(page);
    },
    changePage1(page) {
      this.getWorkRank("", page);
    },
    getList(type) {
      this.type = type;
    },
    //作品排行榜 cycle:week|year
    getWorkRank(cycle, page) {
      if (cycle) {
        this.currentPage1 = 1;
        this.workRankType = cycle;
      }
      getWorkRank(this.workRankType, this.workRankOrderBy, page || 1, 8).then(
        (res) => {
          if (res.success) {
            this.workRankResult = res.result;
          } else {
            this.$message.error({
              title: "错误",
              description: res.message,
            });
          }
        }
      );
    },
    //精选作品
    getWorkGreat(page) {
      getWorkGreat(page || 1, 8).then((res) => {
        console.log(res);
        if (res.success) {
          this.greatWorkResult = res.result;
        }
      });
    },
    //社区牛人
    getStudentRank() {
      communityCattle("workStarNum", 1, 20).then((res) => {
        console.log(res);
        if (res.success) {
          this.studentRankResult = res.result;
          this.caroulLength = Math.ceil(
            this.studentRankResult.records.length / 5
          );
        }
      });
    },
    toDetail(workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`,
      });
    },
    toFriend(userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`,
      });
    },
  },
};
</script>
<style lang="scss">
.ivu-select-selected-value {
  color: #000 !important;
}
.page li {
  a {
    color: #515a6e !important;
  }
}
.community {
  .wdd {
    width: 1050px;
    margin: 0 auto;
  }
  .carousel {
    .ivu-carousel-dots {
      display: block;
      position: absolute;
      bottom: 88px;
      padding-right: 20px;
      .ivu-carousel-active button {
        background: #fff;
      }
      button {
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        background: unset;
        border-radius: 50%;
        opacity: 1;
        margin-right: 8px;
      }
    }
    .ivu-carousel-arrow {
      background: unset;
      .ivu-icon {
        font-size: 54px;
        opacity: 0.6;
      }
    }
  }
  .card-list .ivu-card-shadow {
    box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.1);
    .ivu-card-body {
      padding: 0;
    }
  }
  .card-list2 .ivu-card-shadow {
    box-shadow: 0px 0px 5px rgba(14, 118, 161, 0.407843137254902);
    .ivu-card-body {
      padding: 0;
    }
  }
  .page {
    .ivu-page-item {
      width: 50px;
      height: 50px;
      line-height: 50px;
      border-radius: 50%;
    }
  }

  .ivu-anchor-link {
    .ivu-anchor-link-title {
      color: #fff !important;

      white-space: unset;
      width: 30px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .ivu-anchor-ink {
    display: none;
  }

  .ivu-carousel-arrow > * {
    vertical-align: super;
  }
}
.community-modal .overtime {
  text-align: center;
  padding: 10px 20px 0;
  .icon {
    margin-right: 20px;
    font-size: 35px;
    color: #f28300;
    vertical-align: middle;
  }
  p {
    vertical-align: middle;
  }
}
</style>
<style lang="scss" scoped>
#basic_usage1 {
  img {
    width: 440px;
    height: 245px;
    transition: all 0.2s ease-out;
    &:hover {
      transform: scale(1.05);
    }
  }
}

.community {
  background: #fff;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
  color: #333;
  font-size: 36px;
  .carousel {
    font-size: 0;
    width: 100%;
    height: 751px;
    margin-top: -80px;
    padding-top: 80px;
    background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
    img {
      width: 1200px;
      height: 614px;
    }
    p {
      background: rgba(245, 154, 35, 1);
      font-size: 20px;
      font-weight: 700;
      color: #fff;
      line-height: 56px;
    }
  }
  .wave {
    z-index: 999;
    position: relative;
    img {
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 100%;
    }
  }
  .content {
    padding: 0 65px;
    text-align: left;
    .title {
      .tip {
        margin-left: 10px;
        font-size: 22px;
        font-family: "Microsoft YaHei";
        margin-top: 20px;
        vertical-align: middle;
      }
      .select {
        font-size: 13px;
        margin: 66px 0 50px 70px;
        a {
          color: #999 !important;
          line-height: 40px;
          display: inline-block;
          border-radius: 40px;
          padding: 0 35px;

          &.selected {
            color: #fff !important;
            background-color: rgba(57, 165, 239, 1);
            box-shadow: 5px 5px 5px rgba(57, 169, 229, 0.349019607843137);
          }
        }

        &:hover {
          color: #333;
        }
      }
    }
    .card-list {
      margin-right: 30px;
      margin-bottom: 40px;
      &:last-child {
        margin-right: 0;
      }
      .card {
        width: 217px;
        text-align: left;
        color: #999;
        .pic {
          width: 100%;
          height: 129px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.2s ease-out;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        .card-content {
          padding: 8px 20px;
          font-size: 14px;
          .title {
            color: #666;
            font-size: 16px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .num {
            font-size: 12px;
            span {
              margin-right: 5px;
            }
          }
        }
        .footer {
          padding: 4px 20px;
          font-size: 12px;
          padding-bottom: 10px;
          .q {
            background: #ccc;
            border-radius: 50%;
            padding: 2px 6px;
            color: #fff;
            width: 26px;
            height: 26px;
            font-size: 20px;
            line-height: 20px;
          }
        }
      }
    }
    .card-list2 {
      margin-right: 30px;
      margin-bottom: 20px;
      &:last-child {
        margin-right: 0;
      }
      .card {
        width: 164px;
        text-align: left;
        color: #999;
        .pic {
          width: 100%;
          height: 108px;
          overflow: hidden;
          text-align: center;
          padding: 15px 0;
          img {
            width: 78px;
            height: 78px;
            transition: all 0.2s ease-out;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        .card-content {
          padding: 4px;
          font-size: 14px;
          .title {
            color: #666;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
          }
          .num {
            border-bottom: 1px solid #e8e8e8;
            text-align: center;
            padding-bottom: 4px;
            span {
              font-size: 12px;
            }
            p {
              font-weight: 700;
            }
          }
        }
        .tip {
          color: #999;
          padding: 5px 0;
        }
      }
    }
    .page {
      text-align: center;
      font-size: 16px;
      padding-top: 20px;
      padding-bottom: 60px;
    }
  }
  .anchor-link {
    z-index: 999;
    position: fixed;
    top: 240px;
    left: 30px;
    width: 64px;
    background: transparent;
    padding: 4px 0;
    .ivu-anchor-ink {
      display: none;
    }
    li {
      margin: 0 auto 4px;
      width: 45px;
      height: 45px;
      position: relative;
      border-radius: 50%;
      box-shadow: 2px 2px 5px rgba(226, 198, 166, 0.349019607843137);
      svg {
        width: 23px;
        height: 23px;
        vertical-align: 7%;
      }
      .word {
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 0;
        width: 45px;
        height: 45px;
        line-height: 45px;
        background: rgba(208, 165, 102, 0.8);
        color: #fff;
        font-size: 12px;
      }
    }
    .more {
      width: 40px;
      margin: 0 auto;
      text-align: center;
      span {
        color: #feb745;
        font-size: 22px;
      }
      p {
        color: #6f6f77;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/community.vue